<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-primary">{{ tableTitle }}</h4>
          </template>
          <template v-slot:headerAction>
            <div class="row" style="padding: 10px">
              <b-form-input
                id="filter-input"
                class="col m-2"
                style="width: 300px; height: 35px"
                v-model="filter"
                type="search"
                :placeholder="$t('inputs.search')"
              ></b-form-input>
              <b-button
                class="col m-2"
                variant="primary"
                style="white-space: nowrap"
                :to="'/' + $i18n.locale + addBtn.link"
                ><i class="fas fa-plus"></i> {{ addBtn.text }}</b-button
              >
            </div>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col md="12" class="table-responsive">
                <b-table
                  bordered
                  :filter="filter"
                  @filtered="onFiltered"
                  hover
                  :per-page="20"
                  :current-page="currentPage"
                  :items="rows"
                  id="my-table"
                  :fields="cols"
                  foot-clone
                >
                  <template v-slot:cell(name)="data">
                    <span>{{ data.item.name }}</span>
                  </template>
                  <template v-slot:cell(roles)="data">
                    <span v-for="role of data.item.roles" :key="role"
                      ><span
                        v-if="role === 'SUPER_ADMIN'"
                        class="text-danger"
                        >{{ role }}</span
                      >
                      <span v-else-if="role === 'ADMIN'" class="text-warning">{{
                        role
                      }}</span>
                      <span
                        v-else-if="role === 'STANDARD'"
                        class="text-primary"
                        >{{ role }}</span
                      >
                      <span v-else>{{ role }}</span
                      ><br
                    /></span>
                  </template>
                  <template v-slot:cell(service)="data">
                    <span v-if="data.item.service">
                      {{ data.item.service.name }}
                    </span>
                  </template>
                  <template v-slot:cell(action)="data">
                    <b-button
                      variant=" iq-bg-success mr-1 mt-1"
                      size="sm"
                      @click="edit(data.item.id)"
                      ><i class="ri-ball-pen-fill m-0"></i
                    ></b-button>
                    <b-button
                      variant=" iq-bg-danger mr-1 mt-1"
                      size="sm"
                      @click="onRemove(data.item)"
                      ><i class="ri-delete-bin-line m-0"></i
                    ></b-button>
                  </template>
                </b-table>
                <b-pagination
                  class="mt-3 pull-right"
                  v-model="currentPage"
                  :total-rows="rows.length"
                  :per-page="20"
                  aria-controls="my-table"
                ></b-pagination>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-1" title="Attention!" @ok="remove(item)">
      <p class="my-4">
        Etes vous sure de vouloir supprimer la fonction
        <span class="bold text-danger">{{ modalMsg }}</span> ?
      </p>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";
import ApiService from "../../Utils/axios";

export default {
  name: "UiDataTable",
  props: {
    addBtn: Object,
    tableTitle: String,
    rows: Array,
    cols: Array,
    fetchList: Function,
  },
  mounted() {
    xray.index();
  },
  methods: {
    default() {
      return {
        id: this.rows.length,
      };
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id) {
      this.$router.push("/" + this.$i18n.locale + "/function/edit/" + id);
    },
    onRemove(item) {
      this.item = item;
      this.modalMsg = item.title;
      this.$bvModal.show("modal-1");
    },
    remove(item) {
      let api = new ApiService();
      api
        .delete("/api/position/" + item.id)
        .then((res) => {
          this.fetchList();
          this.$store.dispatch("Alert/activate", {
            text: "Fonction supprimé avec succée",
            type: "success",
          });
        })
        .catch((err) => {
          if (err.response.data.code && err.response.data.code === "23000") {
            this.$store.dispatch("Alert/activate", {
              text: "La fonction ne peut pas être supprimé parce qu'elle est utilisé par d'autres entités du système",
              type: "danger",
            });
          } else {
            this.$store.dispatch("Alert/activate", {
              text: "Une erreur est survenue, veuillez réessayer ultérieurement ou contacter l'administration.",
              type: "danger",
            });
          }
        });
    },
  },
  data() {
    return {
      currentPage: 1,
      filter: "",
      modalMsg: "",
      item: null,
    };
  },
};
</script>
